let xmlRequest = `
<?xml version="1.0" encoding="UTF-8"?>
<request>
    <deliveryOrder>
        <warehouseCode>仓库编码, string (50), 必填</warehouseCode>
        <ownerCode>货主编码, string (50), 必填</ownerCode>
        <deliveryOrderCode>ERP单号, string (50), 必填</deliveryOrderCode>
    </deliveryOrder>
</request>
`

let xmlResponse = `
<?xml version="1.0" encoding="utf-8"?>
<response>
    <flag>success|failure</flag>
    <code>响应码</code>
    <message>响应信息</message>
    <deliveryOrder>
        <warehouseCode>仓库编码, string (50)</warehouseCode>
        <ownerCode>货主编码, string (50)</ownerCode>
        <deliveryOrderCode>ERP单号, string (50)</deliveryOrderCode>
        <deliveryOrderId>WMS单号, string (50)</deliveryOrderId>
        <orderType>订单类型, string (50) (只传英文编码)</orderType>
        <status>订单状态, string (50), created=创建, allocated=分配完成, adopted=认领, picked=拣货完成, canceled=取消, closed=关闭, checked=复核完成, shipped=发运完成, part_allocated=部分分配, part_picked=部分拣货, part_checked=部分复核, part_shipped=部分发运(只传英文编码)</status>
        <shopNick>店铺名称, string (50)</shopNick>
        <logisticsName>快递公司, string (200)</logisticsName>
        <expressCode>面单号, string (50)</expressCode>
        <userDefined1>用户自定义1, string (50)</userDefined1>
        <userDefined2>用户自定义2, string (50)</userDefined2>
        <userDefined3>用户自定义3, string (50)</userDefined3>
        <userDefined4>用户自定义4, string (50)</userDefined4>
        <createTime>创建时间, string (19), YYYY-MM-DD HH:MM:SS</createTime>
        <updateTime>更新时间, string (19), YYYY-MM-DD HH:MM:SS</updateTime>
        <remark>备注, string (500)</remark>
        <receiverInfo>
            <name>收件人姓名, string (50)</name>
            <tel>收件人电话, string (50)</tel>
            <province>省, string (50)</province>
            <city>市, string (50)</city>
            <area>区, string (50)</area>
            <detailAddress>详细地址, string (200)</detailAddress>
        </receiverInfo>
    </deliveryOrder>
</response>
`

export default {xmlRequest, xmlResponse}



// WEBPACK FOOTER //
// ./src/data/openapi/openapi.stockout.query.js